// extracted by mini-css-extract-plugin
export default {"footer":"UsersTableFooter_footer__Oloca","footer_with_dialog_buttons":"UsersTableFooter_footer_with_dialog_buttons__hfNWG","button":"UsersTableFooter_button__qq9+l"};